module.exports = __webpack_public_path__ + "img/notification-wa.03886b0b.svg";